import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

export const getPreClaimsReasonTypesAPI = () => {
  return axiosInstance.request({
    url: `${API.PRECLAIM}/GetClaimReasonType`,
    method: 'get',
  });
};

export type PreClaimsReasonTypesResponse = {
  reasonType: string;
  reasonTypeDesc: string;
}[];

export const fetchPreClaimsReasonTypes = async (): Promise<PreClaimsReasonTypesResponse> => {
  const response: AxiosResponse<PreClaimsReasonTypesResponse> = await getPreClaimsReasonTypesAPI();
  return response.data;
};
